var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.animationBackground.scrolledAnimationFlag)?_c('div',{staticClass:"LLAttentionBackground",style:(_vm.style)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }